import * as React from "react";
import type { SVGProps } from "react";
const SvgScaleIndividually = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M30.936 30.508c4.73 0 8.566-3.846 8.566-8.59 0-4.745-3.835-8.592-8.566-8.592-4.73 0-8.566 3.847-8.566 8.591 0 4.745 3.835 8.59 8.566 8.59Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M30.936 14.11c-4.3 0-7.785 3.495-7.785 7.807s3.486 7.808 7.785 7.808c4.3 0 7.786-3.496 7.786-7.808 0-4.312-3.486-7.808-7.786-7.808Zm-9.346 7.807c0-5.177 4.184-9.373 9.346-9.373s9.347 4.196 9.347 9.373-4.185 9.374-9.347 9.374-9.346-4.197-9.346-9.374Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M44.342 50.674H19.776c-1.278 0-2.42-.871-2.566-2.143-1.112-10.03 9.415-12.72 15.19-12.769 12.43.734 14.84 7.916 14.43 12.837-.107 1.243-1.23 2.085-2.478 2.085l-.01-.01Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.42 34.98h.027c6.36.376 10.299 2.414 12.58 5.126 2.273 2.701 2.798 5.951 2.581 8.558v.003c-.15 1.73-1.691 2.8-3.256 2.8h-.323l-.01-.01H19.777c-1.608 0-3.143-1.106-3.342-2.837v-.003c-.294-2.654.18-4.868 1.185-6.685 1.002-1.81 2.506-3.18 4.202-4.2 3.372-2.027 7.599-2.727 10.573-2.753h.026Zm-13.435 7.712c-.835 1.508-1.26 3.39-.999 5.75.095.813.842 1.449 1.79 1.449h24.778c.83-.081 1.438-.66 1.499-1.358.192-2.315-.282-5.115-2.22-7.418-1.925-2.29-5.399-4.208-11.451-4.57-2.8.028-6.71.698-9.758 2.53-1.519.913-2.8 2.1-3.639 3.616ZM0 .783C0 .35.35 0 .78 0h18.762c.43 0 .78.35.78.783 0 .432-.35.783-.78.783H1.56v18.032a.782.782 0 1 1-1.561 0V.783ZM43.678.783c0-.433.35-.783.78-.783H63.22c.431 0 .78.35.78.783v18.815a.782.782 0 1 1-1.56 0V1.566h-17.98a.782.782 0 0 1-.781-.783Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M43.678 4.96c0-.432.35-.782.78-.782h14.596c.43 0 .78.35.78.783v14.637a.782.782 0 1 1-1.561 0V5.743H44.458a.782.782 0 0 1-.78-.782ZM4.165 4.96c0-.432.35-.782.78-.782h14.596a.782.782 0 0 1 0 1.565H5.726v13.855a.782.782 0 1 1-1.561 0V4.961ZM59.053 43.502c.431 0 .78.35.78.782v14.638c0 .432-.349.783-.78.783H44.459a.782.782 0 0 1 0-1.566h13.815V44.284c0-.432.35-.782.78-.782ZM4.946 43.502c.43 0 .78.35.78.782V58.14h13.815a.782.782 0 0 1 0 1.566H4.946a.782.782 0 0 1-.781-.783V44.284c0-.432.35-.782.78-.782Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M.78 43.619c.432 0 .781.35.781.783v18.032h17.98a.782.782 0 0 1 0 1.566H.782A.782.782 0 0 1 0 63.217V44.402c0-.433.35-.783.78-.783ZM63.22 43.502c.43 0 .78.35.78.782V63.1c0 .432-.35.783-.78.783H44.457a.782.782 0 0 1 0-1.566h17.98V44.284c0-.432.35-.782.781-.782Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScaleIndividually;
